import { useState } from 'react'
import VaulDrawer from '../BottomSheetComponents/VaulDrawer'
import UnlockEliteBottomSheet from '../BottomSheetComponents/UnlockEliteBottomSheet'
import { EliteIcon } from '../../icons/EliteIcon'
import { trackEvent } from '../../utils/appBridge'
import { EventNames } from '../../types/misc.types'
import { usePeerAnalyserStore } from '../../state-management/peerAnalyserStore'

const EliteOfferBadge = ({ fundCategory, tenureInDays }: any) => {
  const [openBottomSheet, setOpenBottomSheet] = useState(false)
  const selectedCategoryId = usePeerAnalyserStore((state) => state.selectedCategoryId)

  const handleViewOfferClick = () => {
    // Track View Offer click
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName: 'PeerAnalyser',
        buttonLabel: 'View Offer',
        eventId: selectedCategoryId
      }
    })
    setOpenBottomSheet((open) => !open)
  }

  return (
    <div className='bg-[#ffffff] relative rounded-xl w-full' data-testid='elite-offer-badge'>
      <div className='flex flex-col items-center relative w-full'>
        <div className='box-border flex flex-col gap-3 items-center justify-start px-[7px] py-4 min-w-[150px]'>
          <div className='box-border flex flex-col gap-2 items-center w-full'>
            <div className='box-border flex flex-row items-center justify-center pl-2 pr-2.5 relative rounded-[10px] bg-white'>
              <EliteIcon />
            </div>
            <div className='font-medium text-[#232323] text-[13px] text-center'>
              <p className='leading-[1.4]'>Get free access to Elite insights for this category</p>
            </div>
          </div>
          <div
            onClick={handleViewOfferClick}
            className='font-medium text-[#cc5c2d] text-[13px] text-center whitespace-nowrap cursor-pointer'
          >
            <p className='leading-[1.3]'>View offer</p>
          </div>
        </div>
      </div>
      <VaulDrawer open={openBottomSheet} setOpen={setOpenBottomSheet}>
        <UnlockEliteBottomSheet
          tenureInDays={tenureInDays}
          fundCategory={fundCategory}
          onDismiss={() => setOpenBottomSheet((open) => !open)}
        />
      </VaulDrawer>
    </div>
  )
}

export default EliteOfferBadge
